import React, { useState } from 'react';
import moment from 'moment';
import { useBreakpoints } from 'kb-components/core/useBreakpoints';

import { ReactComponent as CloseIcon } from '../../../../assets/icons/close-icon.svg';
import { currencyNumberFormat } from '../../../../utilities/number-format';
import { OutlineButton } from '../../../../components/Buttons';
import Invoice from '../../types/invoice';
import Modal from '../../../../components/Modal';
import PaymentDetails from './PaymentDetails';
import * as Styled from './InvoicePayModal.styled';

interface Props {
  invoice?: Invoice;
  open: boolean;
  onClose: () => void;
  onPayInvoice: (data: { cardHolderName: string }) => Promise<void>;
}

const InvoicePayModal = ({ open, invoice, onClose, onPayInvoice }: Props) => {
  const [cardHolderName, setCardHolderName] = useState('');
  const [loading, setLoading] = useState(false);
  const { isMobile } = useBreakpoints();

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setLoading(true);
    await onPayInvoice({ cardHolderName });
    setLoading(false);
    setCardHolderName('');
  };

  return (
    <Modal label="Make a payment" open={open} onRequestClose={onClose} mobileFullscreen>
      <Styled.Form onSubmit={onSubmit}>
        {isMobile ? (
          <Styled.CloseArrowButton type="button" onClick={onClose}>
            Your invoices
          </Styled.CloseArrowButton>
        ) : (
          <Styled.CloseIconButton type="button" onClick={onClose}>
            <CloseIcon width={20} height={20} />
          </Styled.CloseIconButton>
        )}

        <Styled.Header>Make a payment</Styled.Header>

        <Styled.FlexContainer>
          <Styled.InvoiceField>
            <Styled.Label>Appointment</Styled.Label>
            <Styled.Value>{invoice?.service}</Styled.Value>
          </Styled.InvoiceField>

          <Styled.InvoiceField>
            <Styled.Label>Date of service</Styled.Label>
            <Styled.Value>{moment(invoice?.dateOfInvoice).format('MM/DD/YYYY')}</Styled.Value>
          </Styled.InvoiceField>

          <Styled.InvoiceField>
            <Styled.Label>Invoice number</Styled.Label>
            <Styled.Value>{invoice?.azEncounterIdentifier || invoice?.id}</Styled.Value>
          </Styled.InvoiceField>

          <Styled.InvoiceField>
            <Styled.Label>Amount</Styled.Label>
            <Styled.Value>{currencyNumberFormat(invoice?.balance ?? 0)}</Styled.Value>
          </Styled.InvoiceField>
        </Styled.FlexContainer>

        <PaymentDetails
          cardHolderName={cardHolderName}
          onCardHolderNameChange={setCardHolderName}
        />

        <Styled.FormActions>
          <Styled.PayButton type="submit" loading={loading} disabled={loading} text="PAY" />
          <OutlineButton type="button" onClick={onClose}>
            Cancel
          </OutlineButton>
        </Styled.FormActions>
      </Styled.Form>
    </Modal>
  );
};

export default InvoicePayModal;
